import { Component, Input, Output, OnInit, EventEmitter, ChangeDetectionStrategy, Inject } from '@angular/core';
import { NgClass, NgIf, CurrencyPipe, DatePipe, NgForOf } from '@angular/common';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FuseCardComponent } from '@fuse/components/card';
import { Configuration, TFMService } from 'app/mock-api/tfm.service';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CarouselAllModule } from '@syncfusion/ej2-angular-navigations';
import { MatTabsModule } from '@angular/material/tabs';
import { FuseDrawerComponent } from '@fuse/components/drawer';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'quote-view-dialog',
  standalone: true,
  imports: [NgIf, MatIconModule, CarouselAllModule, MatTabsModule, CurrencyPipe, FuseDrawerComponent, MatButtonModule, GoogleMapsModule, DatePipe, MatTooltipModule, NgForOf, MatDialogModule, NgClass],
  providers: [TFMService],
  templateUrl: './quote-view-dialog.component.html',
  styleUrl: './quote-view-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Default
})
export class QuoteViewDialogComponent implements OnInit {

  public view : any = {
  }
  /**
   * Constructor
   */
  constructor(private _tfmService : TFMService, private _tfmCartService: TFMCartService, private _config: Configuration, public dialogRef: MatDialogRef<QuoteViewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private sanitizer: DomSanitizer)
  {
    this.view.type = data.type;
    this.view.search = data.search;
    this.view.config = data.config;
    this.view.itin = data.itin;

    this.view.quoteViewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this._config.TFMApiLink.href}v1/sites/${this.view.itin.content.itinerary.siteId}/itineraries/${this.view.itin.content.itinerary.guid}/documents/pdf/ss`);
    this.view.quoteDownloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this._config.TFMApiLink.href}v1/sites/${this.view.itin.content.itinerary.siteId}/itineraries/${this.view.itin.content.itinerary.guid}/documents/pdf`);
  }

  /**
  * On init
  */
  ngOnInit(): void {
    
  }

  public apply() {
    this.dialogRef.close(this.view);
  }

  close(): void
  {
      // Close the dialog
      this.dialogRef.close();
  }
}
